export default {
  'pages.layouts.userLayout.title':
    'Ant Design est la spécification de conception web la plus influente dans le district de Xihu',
  'pages.login.accountLogin.tab': 'Connexion avec un compte',
  'pages.login.accountLogin.errorMessage':
    'Nom d’utilisateur/mot de passe incorrect (admin/ant.design)',
  'pages.login.username.placeholder': "Nom d'utilisateur : admin ou utilisateur",
  'pages.login.username.required': "Veuillez entrer votre nom d'utilisateur !",
  'pages.login.password.placeholder': 'Mot de passe : ant.design',
  'pages.login.password.required': 'Veuillez entrer votre mot de passe !',
  'pages.login.phoneLogin.tab': 'Connexion par téléphone',
  'pages.login.phoneLogin.errorMessage': 'Erreur de code de vérification',
  'pages.login.phoneNumber.placeholder': 'Numéro de téléphone',
  'pages.login.phoneNumber.required': 'Veuillez entrer votre numéro de téléphone !',
  'pages.login.phoneNumber.invalid': 'Le numéro de téléphone est invalide !',
  'pages.login.captcha.placeholder': 'Code de vérification',
  'pages.login.captcha.required': 'Veuillez entrer le code de vérification !',
  'pages.login.phoneLogin.getVerificationCode': 'Obtenir le code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Se souvenir de moi',
  'pages.login.forgotPassword': 'Mot de passe oublié ?',
  'pages.login.submit': 'Connexion',
  'pages.login.loginWith': 'Se connecter avec :',
  'pages.login.registerAccount': 'Créer un compte',
  'pages.welcome.advancedComponent': 'Composant avancé',
  'pages.welcome.link': 'Bienvenue',
  'pages.welcome.advancedLayout': 'Mise en page avancée',
  'pages.welcome.content': 'Bonjour et bienvenue sur EscolaLMS !',
  'pages.welcome.alertMessage': 'Des composants plus performants et plus robustes ont été publiés.',
  'pages.admin.subPage.title': 'Cette page ne peut être vue que par un administrateur',
  'pages.admin.subPage.alertMessage':
    "Umi UI est maintenant publié, bienvenue à utiliser 'npm run ui' pour commencer l'expérience.",
  'pages.searchTable.createForm.newRule': 'Nouvelle règle',
  'pages.searchTable.updateForm.ruleConfig': 'Configuration de règle',
  'pages.searchTable.updateForm.basicConfig': 'Informations de base',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nom de la règle',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Veuillez entrer le nom de la règle !',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Description de la règle',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Veuillez entrer au moins cinq caractères',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    "Veuillez entrer une description de règle d'au moins cinq caractères !",
  'pages.searchTable.updateForm.ruleProps.title': 'Configurer les propriétés',
  'pages.searchTable.updateForm.object': 'Objet de surveillance',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Modèle de règle',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Type de Règle',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Définir la Période de Planification',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Heure de Début',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Veuillez choisir une heure de début !',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Nom de la règle requis',
  'pages.searchTable.titleCallNo': "Nombre d'Appels de Service",
  'pages.searchTable.titleStatus': 'Statut',
  'pages.searchTable.nameStatus.default': 'par défaut',
  'pages.searchTable.nameStatus.running': "en cours d'exécution",
  'pages.searchTable.nameStatus.online': 'en ligne',
  'pages.searchTable.nameStatus.abnormal': 'anormal',
  'pages.searchTable.titleUpdatedAt': 'Dernière Planification le',
  'pages.searchTable.exception': "Veuillez entrer la raison de l'exception !",
  'pages.searchTable.titleOption': 'Options',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': "S'abonner aux alertes",
  'pages.searchTable.title': 'Formulaire de demande',
  'pages.searchTable.new': 'Nouveau',
  'pages.searchTable.chosen': 'choisi',
  'pages.searchTable.item': 'élément',
  'pages.searchTable.totalServiceCalls': "Nombre Total d'Appels de Service",
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'suppression en lot',
  'pages.searchTable.batchApproval': 'approbation en lot',
  'pages.files.content': 'Liste des fichiers',
  'pages.files.filesBrowser': 'Le répertoire courant est :',
};
